// McMaster brand colors — single source of truth for the entire frontend.
// All values are consumed by ThemeModeContext to build the MUI theme;
// components should access colors via useTheme() / theme.palette.* instead
// of importing from this file directly.

// Primary palette
export const MAROON = '#7A003C'
export const GOLD = '#FDBF57'
export const GREY = '#495965'

// Dark mode surface colors
export const DARK_BG = '#0e0008'
export const DARK_PAPER = '#240012'

// Dark mode interactive colors
// #D07098 on DARK_PAPER → ~6.2:1 (WCAG AA normal text)
export const DARK_ACCENT = '#D07098'

// Auth layout gradients
export const AUTH_DARK_GRAD_START = '#1a000c'
export const AUTH_DARK_GRAD_END = '#050001'
export const AUTH_LIGHT_GRAD_START = '#fdf5f8'
export const AUTH_LIGHT_GRAD_END = '#f0e0ea'
